import axios, { InternalAxiosRequestConfig } from 'axios'
import { useCallback, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { RefreshActions } from '../state/refresh'

export const AxiosConfigContainer = (): JSX.Element => {
  const dispatch = useDispatch()

  const showSpinner = useCallback((): void => {
    dispatch(RefreshActions.showSpinner())
  }, [dispatch])

  const hideSpinner = useCallback((): void => {
    dispatch(RefreshActions.hideSpinner())
  }, [dispatch])

  const setUpInterceptors = useCallback(async () => {
    axios.interceptors.request.use(
      function (config: InternalAxiosRequestConfig) {
        if ((config as any).showLoader !== false) {
          showSpinner()
        }
        return config
      },
      async function (error) {
        return await Promise.reject(error)
      }
    )

    axios.interceptors.response.use(
      function (response) {
        hideSpinner()
        return response
      },
      async function (error) {
        hideSpinner()
        return await Promise.reject(error)
      }
    )
  }, [hideSpinner, showSpinner])

  useEffect(() => {
    void setUpInterceptors()
  }, [setUpInterceptors])

  return <></>
}
